var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{ref:"menuRef",attrs:{"default-openeds":_vm.defaultOpeneds,"router":true,"default-active":_vm.defaultActive,"background-color":"#fff"}},[_vm._l((_vm.data),function(menu){return [(!_vm.isHidden(menu))?_c('SubMenu',{key:menu.path,attrs:{"menu":menu}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }